<app-coinflip-info-bar />
<app-coinflip-stats />
<app-coinflip-win-notification-container />
<div class="coinflip-games">
  @if (deprecatedCoinflipService.myGames().length > 0) {
  <ul [@listAnimation]="deprecatedCoinflipService.myGames().length">
    @for (myCf of deprecatedCoinflipService.myGames(); track myCf.gameid) {
    <li>
      <app-coinflip-row [coinflip]="myCf"></app-coinflip-row>
    </li>
    }
  </ul>
  <span class="divider horizontal w-full"></span>
  }
  <ul [@listAnimation]="deprecatedCoinflipService.otherGames().length">
    @for (cf of deprecatedCoinflipService.otherGames(); track cf.gameid) {
    <li>
      <app-coinflip-row [coinflip]="cf"></app-coinflip-row>
    </li>
    }
  </ul>
</div>
